export default "__VITE_ASSET__YP0UmiWV__"